@if (canDownload()) {
  <button
    rds-secondary-button
    size="l"
    [attr.aria-label]="downloadLabel()"
    faroAction="offering download markdown"
    (click)="download()"
  >
    <rds-icon namespace="outlined" icon="download" />
    Download .md
  </button>
}
